<template>
    <div class="text-center py-3">
        <AffiliateProgram :allowScrollContainer="false"/>
    </div>
</template>

<script>
export default {
    components: {
        AffiliateProgram: () => import("@/views/AffiliateProgram/AffiliateProgram.vue")
    },
    data() {
        return {
        }
    }
}
</script>